import type { ITopicEntity } from '@1js/cortex-topics-types';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import classnamesBind from 'classnames/bind';
import { observer } from 'mobx-react-lite';
import { SenderImageWrapper } from 'owa-mail-sender-persona-view';
import * as React from 'react';
import BaseDropdownItem, { BaseDropdownItemProps } from './BaseDropdownItem';
import styles from './TopicDropdownItem.scss';

const classNames = classnamesBind.bind(styles);

export interface TopicDropdownItemProps extends BaseDropdownItemProps {
    topic: ITopicEntity;
}

/**
 * Re-usable control for an entry in a dropdown. Used in the topic roll-up and the manual topic annotations.
 */
export default observer(function TopicDropdownItem(props: TopicDropdownItemProps) {
    const displayName = `${props.isManual ? '#' : ''}${props.topic.DisplayName}`;
    return (
        <BaseDropdownItem withHover={true} {...props}>
            {props.isManual && props.item ? (
                <div className={styles.faceContainer}>
                    <SenderImageWrapper
                        message={props.item}
                        displaySelf={false}
                        size={PersonaSize.size24}
                    />
                </div>
            ) : null}
            <div className={styles.topicContainer}>
                <div
                    className={classNames(
                        styles.topicTitle,
                        styles.textOverFlow,
                        props.isManual ? styles.manualTopic : undefined
                    )}>
                    {displayName}
                </div>
                <div
                    className={classNames(
                        styles.topicDescription,
                        styles.textOverFlow,
                        props.isManual ? styles.manualTopic : undefined
                    )}>
                    {props.topic.Definition}
                </div>
            </div>
        </BaseDropdownItem>
    );
});
